export interface SignInInput {
  username: string | undefined;
  email?: string;
  password: string;
}

export interface SignInResponse {
  idToken: {
    jwtToken: string;
    payload: {
      [key: string]: unknown;
    };
  };
  refreshToken: {
    token: string;
  };
  accessToken: {
    jwtToken: string;
    payload: {
      sub: string;
      [key: string]: unknown;
    };
  };
  clockDrift: number;
}

export interface SignInOutput {
  id: string;
  accessToken: string;
}

export enum Gender {
  MALE = 'Male',
  FEMALE = 'Female',
}

export interface AccountDetailsInput {
  email?: string;
  phoneNumber?: string;
  password: string;
  usernameType?: UsernameType;
}

export interface PersonalInformationInput {
  firstName: string;
  lastName: string;
  middleName?: string;
  birthdate: Date;
  gender: string;
}

export interface KitRegistrationInput {
  uniqueId: string;
}

export enum UsernameType {
  None = 'None',
  Email = 'Email',
  Phone = 'Phone',
}

export interface OnsitePersonalInformationInput {
  firstName: string;
  lastName: string;
  middleName?: string;
  birthdate: Date;
  gender: string;
  registeredAt: string;
  termsAndConditions: boolean;
  SMSTermsAndConditions: boolean;
  shareWithPhysicianNetwork: boolean;
  isNotIntendedToDiagnose: boolean;
  event?: string;
  email?: string;
  phoneNumber?: string;
  usernameType?: UsernameType;
}

export interface AddressInformationInput {
  phoneNumber?: string;
  address1: string;
  address2: string;
  country: string;
  city: string;
  state: string;
  zip: string;
  termsAndConditions: boolean;
  SMSTermsAndConditions?: boolean;
  shareWithPhysicianNetwork: boolean;
  isNotIntendedToDiagnose: boolean;
  usernameType?: UsernameType;
}

export interface SignUpInput
  extends AccountDetailsInput,
    PersonalInformationInput,
    AddressInformationInput {
  giftCode?: string;
}

export interface OnsiteSignUpInput
  extends AccountDetailsInput,
    OnsitePersonalInformationInput {
  username?: string;
  phone?: string;
}

export interface CodeVerificationInput {
  username: string | undefined;
  email?: string;
  code: string;
}

export interface ResendCodeInput {
  username: string | undefined;
  email?: string;
}

export interface InitiateResetPasswordInput {
  email: string;
}

export interface InitiateResetPasswordResponse {
  status: string;
  msg: string;
}

export interface ConfirmResetPasswordInput extends InitiateResetPasswordInput {
  code: string;
  newPassword: string;
}

export interface ValidateEmailInput {
  email: string | undefined;
}

export interface ValidatePhoneInput {
  phoneNumber: string;
}
